"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ez = require("ez.js");

var _smoothScroll = _interopRequireDefault(require("smooth-scroll"));

var ProductAccordians = /*#__PURE__*/function () {
  function ProductAccordians(component) {
    (0, _classCallCheck2["default"])(this, ProductAccordians);
    this.dom = {
      $component: component,
      $toggles: Array.from(component.querySelectorAll('.js-ProductAccordians-toggle')),
      $togglesActive: Array.from(component.querySelectorAll('.js-ProductAccordians-toggle-active'))
    }, this.state = {
      active: false,
      scrollTimeout: 400,
      animating: false,
      tolerance: 100,
      activeClass: 'is-active',
      smoothScroll: new _smoothScroll["default"](),
      smoothScrollOptions: {
        speed: 400,
        customEasing: function customEasing(time) {
          return (0, _ez.easeInOutExpo)(time, 0, 1, 1);
        },
        updateURL: false
      }
    };
    this.toggleHandler = this.toggle.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(ProductAccordians, [{
    key: "mount",
    value: function mount() {
      var dom = this.dom,
          state = this.state;
      var self = this;
      console.log('ProductAccordians : mount', this);
      dom.$toggles.forEach(function ($toggle) {
        return $toggle.addEventListener('click', function (event) {
          return self.toggle(event);
        });
      });
      var activeItem = document.querySelector('.ProductAccordion.is-active .js-ProductAccordians-toggle');

      if (activeItem) {
        state.active = activeItem.dataset.key;
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var dom = this.dom,
          state = this.state;
      console.log('ProductAccordians : unmount', this);
    }
  }, {
    key: "toggle",
    value: function toggle(event) {
      var state = this.state;
      event.preventDefault();
      event.stopPropagation();
      console.log('ProductAccordians : toggle', this, event);
      var accordian = event.target.dataset.key;

      if (state.active === accordian) {
        this.close();
      } else if (state.active && accordian !== state.active) {
        this.close();
        this.open(accordian, true);
      } else {
        this.open(accordian);
      }
    }
  }, {
    key: "open",
    value: function open(accordian) {
      var dom = this.dom,
          state = this.state;
      var self = this;
      console.log('ProductAccordians : open', this);
      var target = dom.$component.querySelector(".".concat(accordian));
      var active = dom.$togglesActive.filter(function ($toggle) {
        return $toggle.dataset.key === accordian;
      })[0];
      target.classList.add(state.activeClass);

      if (active) {
        active.classList.add(state.activeClass);
      }

      state.active = accordian;
    }
  }, {
    key: "close",
    value: function close() {
      var dom = this.dom,
          state = this.state;
      console.log('ProductAccordians : close', this);
      var target = dom.$component.querySelector(".".concat(state.active));
      dom.$togglesActive.forEach(function ($toggle) {
        return $toggle.classList.remove(state.activeClass);
      });
      target.classList.remove(state.activeClass);
      state.active = false;
    }
  }]);
  return ProductAccordians;
}();

exports["default"] = ProductAccordians;